import { ApiBacklogClient, ApiListTemplate, UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientId) => async (dispatch) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const url = ApiBacklogClient+'backlog?client='+clientId;
    const argument = {
        method: 'DELETE',
        headers : {
            'Content-Type':'application/json',
            'Authorization': UserToken,
            // 'Authorization': "token123",
        },
    };
    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    
    return response;
    
};